/* eslint-disable angular/module-setter, angular/module-getter */

import { uuid } from '../../../utils/string-utils';

const CHROME_BROWSER = /Chrome/.test(window.navigator.userAgent);

export function disableAutocomplete(element) {
  // fix for LastPass
  element.attr('data-lpignore', 'true');
  // fix for Dashlane
  element.attr('data-form-type', 'other');

  // disables Chrome's stupid autofill which ignores autocomplete because why the hell not?
  // now you have to give Chrome a random value to prevent it from autofilling
  element.attr('autocomplete', CHROME_BROWSER ? uuid() : 'off');
}

export const autocompleteFixesComponentModule = angular
  .module('Q.components.autocomplete-fixes', [])
  .directive('autocomplete', function () {
    return {
      restrict: 'A',
      priority: 1000,
      link(scope, element) {
        if (['off', 'false'].includes(element.attr('autocomplete'))) {
          disableAutocomplete(element);
        }
      },
    };
  });

['datepickerPopup', 'typeahead'].forEach((name) => {
  // augment 3rd-party directives to disable autocomplete
  autocompleteFixesComponentModule.directive(name, function () {
    return {
      restrict: 'A',
      priority: 1000,
      link(scope, element) {
        disableAutocomplete(element);
      },
    };
  });
});
